import { PrinterSchema } from "@redotech/redo-model/printnode/printer";
import * as z from "zod/v4";

export const getPrinters = {
  name: "getPrinters" as const,
  input: z.object({}),
  output: z.object({ enabled: z.boolean(), printers: z.array(PrinterSchema) }),
};
